import Icon from '../components/Icon.vue'

Icon.register({
  'user-astronaut': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M64 224H77.5C102.2 280.5 158.4 320 224 320S345.8 280.5 370.5 224H384C392.8 224 400 216.8 400 208V112C400 103.2 392.8 96 384 96H370.5C345.8 39.5 289.6 0 224 0S102.2 39.5 77.5 96H64C55.2 96 48 103.2 48 112V208C48 216.8 55.2 224 64 224zM104 136C104 113.9 125.5 96 152 96H296C322.5 96 344 113.9 344 136V160C344 213 301 256 248 256H200C147 256 104 213 104 160V136zM176 208L188 172 224 160 188 148 176 112 164 148 128 160 164 172 176 208zM327.6 321.4C297.7 340.7 262.2 352 224 352S150.3 340.7 120.4 321.4C52.9 328.5 0 385 0 454.4V464C0 490.5 21.5 512 48 512H128V448C128 430.3 142.3 416 160 416H288C305.7 416 320 430.3 320 448V512H400C426.5 512 448 490.5 448 464V454.4C448 385 395.1 328.5 327.6 321.4zM272 448C263.2 448 256 455.2 256 464S263.2 480 272 480 288 472.8 288 464 280.8 448 272 448zM176 448C167.2 448 160 455.2 160 464V512H192V464C192 455.2 184.8 448 176 448z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/user-astronaut.js
// module id = JKh9
// module chunks = 144